import type { TInputType } from '@alfa-bank/site-pure-input/src/models/index';
/** Переедет в core-components после перехода всеми командами в АССР и удалении env */
// eslint-disable-next-line package-imports/no-core-components-imports
import type { BaseInputProps } from '@alfalab/core-components-input/components/base-input/Component';

/** Временный хелпер, после перехода на CoreInput не будет нужен */
export const getInputType = (type: TInputType | undefined) => {
    let inputType: BaseInputProps['type'];
    switch (type) {
        /** 'phone' нет в коровском инпуте и в целом это не валидный type для <input>
         *   https://www.w3schools.com/html/html_form_input_types.asp
         */
        case 'phone':
            inputType = 'tel';
            break;
        /** type=hidden нет в корах */
        case 'hidden':
            inputType = undefined;
            break;
        default:
            inputType = type || 'text';
    }

    return inputType;
};
